import {
  BuildingOffice2Icon,
  CalendarDaysIcon,
  TicketIcon,
  AcademicCapIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Event Directory",
    href: "/event-registration/events",
    icon: CalendarDaysIcon,
    current: false,
    internalName: "event-directory",
  },
  {
    name: "My Registrations",
    href: "/event-registration/my-registrations",
    icon: TicketIcon,
    current: false,
    internalName: "my-registrations",
  },
  {
    name: "Company Registrations",
    href: "/event-registration/company-registrations",
    icon: BuildingOffice2Icon,
    current: false,
    internalName: "company-registrations",
    permissions: ["event-registration-company"],
  },
  {
    name: "My Training History",
    href: "/event-registration/my-training-history",
    icon: AcademicCapIcon,
    current: false,
    internalName: "my-training-history",
  },
];

const eventRegistrationConfig = {
  sectionName: "event-registration",
  defaultRoute: "/event-registration/events",
  navigation,
};

export default eventRegistrationConfig;
